import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['paymentMethod', 'paymentBankDetails',
    'paymentCryptoDetails', 'paymentPaypalDetails', 'currency',
    'usdBankDetails', 'eurBankDetails'];

  connect() {
    this.updatePaymentMethodDetails();
    this.updateCurrencyFields();
  }

  updatePaymentMethodDetails() {
    const paymentMethod = this.paymentMethodTarget.value;

    this.paymentBankDetailsTarget.classList.toggle('hidden', paymentMethod !== 'bank_transfer');
    this.paymentCryptoDetailsTarget.classList.toggle('hidden', paymentMethod !== 'crypto');
    this.paymentPaypalDetailsTarget.classList.toggle('hidden', paymentMethod !== 'paypal');
  }

  updateCurrencyFields() {
    const currency = this.currencyTarget.value;

    this.usdBankDetailsTarget.classList.toggle('hidden', currency !== 'USD');
    this.eurBankDetailsTarget.classList.toggle('hidden', currency !== 'EUR');
  }
}
